import Counter from './Counter';
import './Counter.scss';

export default Counter;
